import { Action, Reducer } from 'redux';
import { StatesState, StateActionTypes, StateTypes } from './stateTypes';

export const INITIAL_STATE: StatesState = {
  statesUser: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  },
  statesUserDomainByBodyshop: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const stateReducer: Reducer<StatesState> = (
  state: StatesState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as StateActionTypes;
  switch (actionTypes.type) {
    case StateTypes.GET_STATES_USER:
      return {
        ...state,
        statesUser: { ...state.statesUser, isLoading: true }
      };
    case StateTypes.SAVE_STATES_USER:
      return {
        ...state,
        statesUser: {
          ...state.statesUser,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case StateTypes.RESET_REDUCER_STATES_USER:
      return {
        ...state,
        statesUser: INITIAL_STATE.statesUser
      };
    case StateTypes.GET_STATES_BY_BODYSHOP:
      return {
        ...state,
        statesUserDomainByBodyshop: {
          ...state.statesUserDomainByBodyshop,
          isLoading: true
        }
      };
    case StateTypes.SAVE_STATES_BY_BODYSHOP:
      return {
        ...state,
        statesUserDomainByBodyshop: {
          ...state.statesUserDomainByBodyshop,
          isLoading: false,
          data: actionTypes.payload.data,
          isError: actionTypes.payload.isError,
          errorMessages: actionTypes.payload.errorMessages
        }
      };
    case StateTypes.RESET_REDUCER_STATES_BY_BODYSHOP:
      return {
        ...state,
        statesUserDomainByBodyshop: INITIAL_STATE.statesUserDomainByBodyshop
      };
    default:
      return state;
  }
};

export default stateReducer;
